// extracted by mini-css-extract-plugin
export default {"intro":"ModalEditarDatosMarketingLead_intro__1Zly8","section":"ModalEditarDatosMarketingLead_section__BIYiu","input":"ModalEditarDatosMarketingLead_input__aLtZh"};